import { DocumentNode, gql, useMutation } from '@apollo/client';

export const UPSERT_CLAIM_ADDITIONAL_CONTACT = gql`
  mutation UpsertClaimAdditionalContact($details: ClaimContactInput!) {
    upsertClaimContact(details: $details) {
      uuid
      targetUuid
      type
      firstName
      lastName
      contacts {
        uuid
        type
        value
      }
    }
  }
`;

export const DELETE_CLAIM_ADDITIONAL_CONTACT = gql`
  mutation DeleteClaimAdditionalContact($uuid: String!) {
    deleteClaimContact(uuid: $uuid) {
      result
      nodesDeleted
      relationshipsDeleted
      description
    }
  }
`;

export interface ClaimAdditionalContactInput {
  claimUuid?: string;
  targetUuid?: string;
  type?: string;
  firstName: string;
  lastName: string;
  emailAddress: string | null;
  phoneNumber: string | null;
  uuid?: string;
}

export function useUpsertClaimAdditionalContactMutation() {
  const [upsertClaimAdditionalContactMutation, { loading, error, data }] =
    useMutation(UPSERT_CLAIM_ADDITIONAL_CONTACT as DocumentNode);

  const upsertClaimAdditionalContact = async (
    details: ClaimAdditionalContactInput
  ) => {
    const response = await upsertClaimAdditionalContactMutation({
      variables: {
        details,
      },
    });

    console.log('🔧 [MUTATION HOOK] Response received:', response);

    return response.data?.upsertClaimContact;
  };

  return {
    upsertClaimAdditionalContact,
    loading,
    error,
    data,
  };
}

export function useDeleteClaimContactMutation() {
  const [deleteClaimContactMutation, { loading, error, data }] = useMutation(
    DELETE_CLAIM_ADDITIONAL_CONTACT as DocumentNode
  );

  const deleteClaimContact = async (uuid: string) => {
    const response = await deleteClaimContactMutation({
      variables: {
        uuid,
      },
    });

    return response.data?.deleteClaimContact;
  };

  return {
    deleteClaimContact,
    loading,
    error,
    data,
  };
}
